import React from "react";
import TableView from "./TableView";

const TableContainer = (props) => {
  return <TableView {...props} />;
};

export default TableContainer;
